import { BadRequestError } from '@cian/valuation-utils-component';

import { TThunkAction } from '../../types/redux';
import {
  fetchValidatePhone,
  TValidatePhoneResponse,
  TValidatePhoneRequest,
} from '../../repositories/demand/v1/validate-phone';
import type {
  IValidatePhoneResponse
} from "../../repositories/demand/entities/public_v1_validate_phone/ValidatePhoneResponse";

export const requestValidatePhone = (
  parameters: TValidatePhoneRequest,
): TThunkAction<Promise<IValidatePhoneResponse | BadRequestError | Error>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const res = (await fetchValidatePhone({
        httpApi,
        parameters,
      })) as TValidatePhoneResponse;

      if (res.statusCode === 200) {
        return {
          confirmTimeout: res.response.confirmTimeout,
          status: res.response.status,
        };
      }

      throw new BadRequestError({
        domain: 'requestValidatePhone.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      if (error instanceof BadRequestError) {
        logger.debug('requestValidatePhone: bad request', { message: error.message, domain: error.domain });
      } else {
        logger.error(error, { message: 'requestValidatePhone: server error' });
      }

      return error as Error;
    }
  };
};
